const obterTiposDocumentoAceitos = () => {
  const tiposAceitos = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/vnd.oasis.opendocument.text',
    'application/rtf',
    'text/rtf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.oasis.opendocument.presentation',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'image/gif',
    'application/zip',
    'application/vnd.rar',
    'application/x-rar-compressed',
    'application/x-rar',
    'application/gzip'
  ]
  return tiposAceitos.join(',')
}

export default {
  obterTiposDocumentoAceitos
}
